module.exports = __webpack_public_path__ + "static/media/A1-18-Lupzen-cod116.f0f015ed.png";